import { Grid, makeStyles } from '@material-ui/core'
import { PatientsListTypes } from 'consts/copilotControlConsts'
import React from 'react'
import CopilotReportsNav from './OralHygieneReport/CopilotReportsNav'
import CopilotControlHeader from './components/CopilotControlHeader/CopilotControlHeader'
import PatientsListPicker from './components/CopilotPatientsLists/PatientsListPicker'
import NoAttentionRequired from './components/Widgets/NoAttentionRequired'
import PatientsSentiment from './components/Widgets/PatientsSentiment'
import PatientsWeContacted from './components/Widgets/PatientsWeContacted'
import ScanningSchedule from './components/Widgets/ScanningSchedule'
import ScansAttentionRatioGraph from './components/Widgets/ScansAttentionRatioGraph'
import TimeSaved from './components/Widgets/TimeSaved'
import TotalScans from './components/Widgets/TotalScans'
import useCopilotControl from './hooks/useCopilotControl'
import useCopilotPatientsList from './hooks/useCopilotPatientsList'

const useStyles = makeStyles(theme => ({
  // Figma frame 218: the reports rail sits at the far left, the report content fills the rest.
  page: {
    background: 'var(--copilot-bg-color)',
    borderTop: '1px solid #E6E6E6',
    boxSizing: 'border-box',
    width: '100%',
    height: 'calc(100% - var(--app-header-v2-height))',
    display: 'flex',
    flexDirection: 'row'
  },
  root: props => ({
    flexGrow: 1,
    minWidth: 0,
    height: '100%',
    padding: '0px 40px',
    paddingBottom: 0,

    [theme.breakpoints.up('sm')]: {
      paddingBottom: 0
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: 0
    },
    [theme.breakpoints.up('lg')]: {
      paddingBottom: 20
    },
    [theme.breakpoints.up('xl')]: {
      paddingBottom: 40
    }
  }),
  widgetsContainer: {
    marginTop: 20,
    height: 'calc(100% - var(--app-header-v2-height) - 40px)'
  },
  scansAttentionRatioContainer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center'
  },
  engagementsContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  }
}))

const CopilotControl = () => {
  const classes = useStyles()

  const { selectedPatientsListType, handlePatientListTypeSelected } = useCopilotPatientsList()

  const {
    pastXDays,
    setPastXDays,
    isLoading,
    isUninitialized,
    timeSavedMinutes,
    totalScans,
    totalNeedsAttention,
    virtualCheckups,
    noAttentionRequired,
    patientsWeContacted,
    patientsWeSentBrushing,
    patientsWeSentChewies,
    isLoadingPracticeGuidelines,
    practiceGuidelinesConfiguration = []
  } = useCopilotControl({})

  return (
    <div className={classes.page}>
      <CopilotReportsNav activeReport="copilot" />
      <Grid container className={classes.root} direction="column" wrap="nowrap">
        <Grid item>
          <CopilotControlHeader
            pastXDays={pastXDays}
            setPastXDays={setPastXDays}
            practiceGuidelinesConfiguration={practiceGuidelinesConfiguration}
            isLoadingPracticeGuidelines={isLoadingPracticeGuidelines}
          />
        </Grid>

        <Grid container id="copilot-widgets" wrap="nowrap" className={classes.widgetsContainer}>
          {/* FIRST COLUMN */}
          <Grid container direction="column" item xs={12} sm={3} md={3} lg={3} xl={3} style={{ height: '100%' }}>
            <Grid item>
              <TotalScans value={virtualCheckups} isLoading={isLoading || isUninitialized} />
            </Grid>
            <Grid item style={{ flexGrow: 1, display: 'flex' }}>
              <ScansAttentionRatioGraph
                isLoading={isLoading || isUninitialized}
                isSelected={selectedPatientsListType === PatientsListTypes.NeedsAttention.type}
                totalScans={totalScans}
                totalNeedsAttention={totalNeedsAttention}
                onChangePatientsListType={handlePatientListTypeSelected}
              />
            </Grid>
            <Grid item>
              <NoAttentionRequired value={noAttentionRequired} isLoading={isLoading || isUninitialized} />
            </Grid>
            <Grid item>
              <TimeSaved timeSavedMinutes={timeSavedMinutes} isLoading={isLoading || isUninitialized} />
            </Grid>
          </Grid>
          {/* SECOND COLUMN */}
          <Grid container direction="column" item sm={3} md={3} lg={3} xl={3} style={{ height: '100%' }} wrap="nowrap">
            <Grid item>
              <PatientsWeContacted
                total={patientsWeContacted}
                forBrushing={patientsWeSentBrushing}
                forChewies={patientsWeSentChewies}
                isLoading={isLoading || isUninitialized}
              />
            </Grid>
            <Grid item className={classes.engagementsContainer}>
              <PatientsSentiment
                isSelected={selectedPatientsListType === PatientsListTypes.PatientsSentiment.type}
                onChangePatientsListType={handlePatientListTypeSelected}
              />
            </Grid>
            <Grid item className={classes.engagementsContainer}>
              <ScanningSchedule
                isSelected={selectedPatientsListType === PatientsListTypes.ScanningSchedule.type}
                onChangePatientsListType={handlePatientListTypeSelected}
              />
            </Grid>
          </Grid>
          {/* THIRD COLUMN */}
          <Grid container direction="column" item sm={6} md={6} lg={6} xl={6} style={{ height: '100%' }} wrap="nowrap">
            <Grid item style={{ flexGrow: 1, height: '100%' }}>
              <PatientsListPicker
                type={selectedPatientsListType}
                onChangePatientsListType={handlePatientListTypeSelected}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default CopilotControl
